type TaskWithInstructions = {
  type: string;
  notes?: string | null;
  addressInstructions?: string | null;
  shipment?: { deliveryNotes?: string | null } | null;
};

/** Current delivery text; pickup address instructions keep their own source. */
export function taskInstructions(task: TaskWithInstructions): string | null {
  if (task.type === "CUSTOMER_DELIVERY") {
    return task.shipment?.deliveryNotes?.trim() || null;
  }
  return task.addressInstructions?.trim() || null;
}

/** Whether a Task has a current instruction or a separate handling note. */
export function taskHasVisibleNote(task: TaskWithInstructions): boolean {
  return Boolean(
    taskInstructions(task) ||
      (task.type !== "CUSTOMER_DELIVERY" && task.notes?.trim())
  );
}

export function taskInstructionLabel(task: TaskWithInstructions): string {
  return task.type === "CUSTOMER_DELIVERY" ? "Delivery instructions" : "Access";
}
